import { BookOpen, Calendar } from 'lucide-react';

interface HomeworkHeaderProps {
  todayHomeworkCount: number;
  onToggleToday: () => void;
}

export function HomeworkHeader({ todayHomeworkCount, onToggleToday }: HomeworkHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <div className="h-11 w-11 rounded-xl bg-indigo-50 dark:bg-indigo-950/50 border border-indigo-200 dark:border-indigo-800/60 flex items-center justify-center text-indigo-600 dark:text-indigo-400 shrink-0 shadow-2xs">
          <BookOpen className="h-6 w-6" />
        </div>
        <div>
          <h2 className="text-xl sm:text-2xl font-black text-slate-900 dark:text-white tracking-tight">
            Homework & Tasks
          </h2>
          <p className="text-xs sm:text-sm text-slate-500 dark:text-slate-400 font-medium mt-0.5">
            View your homework, assignments and tasks assigned by your teachers.
          </p>
        </div>
      </div>

      {/* Today's Homework Pill Badge Button */}
      <button
        type="button"
        onClick={onToggleToday}
        className="inline-flex items-center gap-2 bg-[#fff7ed] text-[#ea580c] dark:bg-orange-950/40 dark:text-orange-300 border border-[#fed7aa] dark:border-orange-800/60 px-4 py-2 rounded-xl text-xs sm:text-sm font-bold shadow-2xs shrink-0 self-start sm:self-auto hover:scale-[1.02] active:scale-[0.98] transition-all cursor-pointer"
      >
        <Calendar className="h-4 w-4 text-[#ea580c] dark:text-orange-400" />
        <span>Today's Homework ({todayHomeworkCount})</span>
      </button>
    </div>
  );
}
